import { type PropsWithChildren } from 'react';
import { Provider } from 'react-redux';

import type { ReducersMapObject } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import { createReduxStore } from '../config/store';

interface StoreProviderProps extends PropsWithChildren {
    initialState?: Partial<AppStateSchema>;
    asyncReducers?: Partial<ReducersMapObject<AppStateSchema>>;
}

export function StoreProvider(props: StoreProviderProps) {
    const { children, initialState, asyncReducers } = props;

    const store = createReduxStore(initialState, asyncReducers);
    const persistedStore = persistStore(store);

    return (
        <Provider store={store}>
            <PersistGate
                loading={null}
                persistor={persistedStore}
            >
                {children}
            </PersistGate>
        </Provider>
    );
}
